/* eslint-disable */
import { gql } from '@apollo/client';

export const CREATE_APPOINTMENT = gql`
    mutation MakeAppointment(
        $recipients: [ID!]
        $beginsAt: String!
        $endsAt: String!
        $eventName: String!
        $location: String!
        $message: String!
    ) {
        makeAppointment(
            recipients: $recipients
            beginsAt: $beginsAt
            endsAt: $endsAt
            eventName: $eventName
            location: $location
            message: $message
        ) {
            recipients {
                recordId
                firstName
                middleName
                lastName
                address {
                    stateProvince
                    country
                }
                title
                photoUrl
            }
            message
            location
            beginsAt
            endsAt
        }
    }
`;
